export const tr = {
  // Auth
  auth: {
    welcomeBack: 'Tekrar hoş geldiniz',
    signInToAccount: 'Mova Dijital hesabınıza giriş yapın',
    emailAddress: 'E-posta adresi',
    password: 'Şifre',
    signIn: 'Giriş Yap',
    signingIn: 'Giriş yapılıyor...',
    loginSuccessful: 'Giriş başarılı!',
    loginFailed: 'Giriş başarısız',
    invalidCredentials: 'Geçersiz kimlik bilgileri',
    logout: 'Çıkış Yap',
    manageAgency: 'Markanızı güvenle yönetin',
    completeControl: 'Güçlü bir platformda müşteriler, projeler ve hizmetler üzerinde tam kontrol.',
  },

  // Common
  common: {
    loading: 'Yükleniyor...',
    save: 'Kaydet',
    cancel: 'İptal',
    delete: 'Sil',
    edit: 'Düzenle',
    create: 'Oluştur',
    update: 'Güncelle',
    add: 'Ekle',
    remove: 'Kaldır',
    search: 'Ara',
    filter: 'Filtrele',
    actions: 'İşlemler',
    status: 'Durum',
    date: 'Tarih',
    confirm: 'Onayla',
    close: 'Kapat',
    submit: 'Gönder',
    required: 'Zorunlu',
    optional: 'İsteğe bağlı',
  },

  // Sidebar
  sidebar: {
    agencyOS: 'Mova Dijital',
    dashboard: 'Gösterge Paneli',
    clients: 'Müşteriler',
    staff: 'Personel',
    content: 'İçerik',
    calendar: 'Takvim',
    adsReports: 'Reklam Raporları',
    receipts: 'Makbuzlar',
    campaigns: 'Kampanyalar',
    activityLogs: 'Aktivite Logları',
    videoProduction: 'Video Prodüksiyon',
    socialMedia: 'Sosyal Medya',
    metaAds: 'Meta Reklamları',
    graphicDesign: 'Grafik Tasarım',
    websiteSetup: 'Web Sitesi Kurulumu',
    ecommerce: 'E-ticaret',
  },

  // Admin Dashboard
  admin: {
    dashboard: {
      title: 'Yönetici Paneli',
      totalClients: 'Toplam Müşteri',
      activeClients: 'Aktif Müşteri',
      videosProduced: 'Üretilen Video',
      designsCreated: 'Oluşturulan Tasarım',
      quickActions: 'Hızlı İşlemler',
      recentActivity: 'Son Aktiviteler',
      noRecentActivity: 'Son aktivite yok',
      addNewClient: 'Yeni Müşteri Ekle',
      uploadContent: 'İçerik Yükle',
      reviewPendingReceipts: 'Bekleyen Makbuzları İncele',
    },
    clients: {
      title: 'Müşteriler',
      addClient: 'Müşteri Ekle',
      editClient: 'Müşteri Düzenle',
      deleteClient: 'Müşteri Sil',
      companyName: 'Şirket Adı',
      contactName: 'İletişim Adı',
      contactEmail: 'İletişim E-postası',
      contactPhone: 'İletişim Telefonu',
      industry: 'Sektör',
      status: 'Durum',
      accessDays: 'Erişim Günleri',
      active: 'Aktif',
      readOnly: 'Salt Okunur',
      expired: 'Süresi Dolmuş',
      noClients: 'Henüz müşteri yok. Başlamak için ilk müşterinizi ekleyin.',
      deleteConfirm: 'Bu müşteriyi silmek istediğinizden emin misiniz?',
      clientCreated: 'Müşteri başarıyla oluşturuldu',
      clientUpdated: 'Müşteri başarıyla güncellendi',
      clientDeleted: 'Müşteri başarıyla silindi',
      failedToLoad: 'Müşteriler yüklenemedi',
      operationFailed: 'İşlem başarısız',
    },
    staff: {
      title: 'Personel Yönetimi',
      addStaff: 'Personel Ekle',
      editStaff: 'Personel Düzenle',
      fullName: 'Ad Soyad',
      email: 'E-posta',
      role: 'Rol',
      permissions: 'İzinler',
      canManageClients: 'Müşteri Yönetimi',
      canManageContent: 'İçerik Yönetimi',
      canViewReports: 'Rapor Görüntüleme',
      canApproveReceipts: 'Makbuz Onaylama',
      canManageCalendar: 'Takvim Yönetimi',
      noStaff: 'Henüz personel yok.',
    },
    content: {
      title: 'İçerik Yönetimi',
      uploadVideo: 'Video Yükle',
      uploadDesign: 'Tasarım Yükle',
      videos: 'Videolar',
      designs: 'Tasarımlar',
      fileName: 'Dosya Adı',
      projectName: 'Proje Adı',
      client: 'Müşteri',
      uploadDate: 'Yükleme Tarihi',
      status: 'Durum',
      uploaded: 'Yüklendi',
      approved: 'Onaylandı',
      revisionRequested: 'Revizyon İstendi',
    },
    calendar: {
      title: 'Takvim',
      addEvent: 'Etkinlik Ekle',
      shootSchedule: 'Çekim Programı',
      contentDeadlines: 'İçerik Son Tarihleri',
      meetings: 'Toplantılar',
      eventType: 'Etkinlik Türü',
      eventTitle: 'Etkinlik Başlığı',
      eventDate: 'Etkinlik Tarihi',
      location: 'Konum',
      notes: 'Notlar',
      shoot: 'Çekim',
      deadline: 'Son Tarih',
      meeting: 'Toplantı',
    },
    adsReports: {
      title: 'Reklam Raporları',
      addReport: 'Rapor Ekle',
      dailySpend: 'Günlük Harcama',
      impressions: 'Gösterim',
      clicks: 'Tıklama',
      conversions: 'Dönüşüm',
      cpc: 'TBM (TıklamaBasıMaliyet)',
      cpm: 'GBM (GösterimBasıMaliyet)',
      campaignName: 'Kampanya Adı',
      reportDate: 'Rapor Tarihi',
    },
    receipts: {
      title: 'Makbuz Yönetimi',
      pending: 'Beklemede',
      approved: 'Onaylandı',
      rejected: 'Reddedildi',
      amount: 'Tutar',
      paymentDate: 'Ödeme Tarihi',
      client: 'Müşteri',
      receiptFile: 'Makbuz Dosyası',
      adminNotes: 'Yönetici Notları',
      approve: 'Onayla',
      reject: 'Reddet',
      approveReceipt: 'Makbuzu Onayla',
      rejectReceipt: 'Makbuzu Reddet',
      receiptApproved: 'Makbuz onaylandı',
      receiptRejected: 'Makbuz reddedildi',
      accessActivated: 'Ödeme onaylandı - Erişim 30 gün için aktifleştirildi',
    },
    campaigns: {
      title: 'Kampanya Oluşturucu',
      createCampaign: 'Kampanya Oluştur',
      campaignTitle: 'Kampanya Başlığı',
      campaignContent: 'Kampanya İçeriği',
      campaignType: 'Kampanya Türü',
      popup: 'Pop-up',
      banner: 'Banner',
      modal: 'Modal',
      fullscreen: 'Tam Ekran',
      startDate: 'Başlangıç Tarihi',
      endDate: 'Bitiş Tarihi',
      targeting: 'Hedefleme',
      targetServiceMissing: 'Hizmeti Olmayan Müşteriler',
      targetSpecificClients: 'Belirli Müşteriler',
      ctaType: 'Eylem Türü',
      form: 'Form',
      whatsapp: 'WhatsApp',
      call: 'Arama',
      ctaLink: 'Eylem Linki',
      isActive: 'Aktif',
    },
    logs: {
      title: 'Aktivite Logları',
      user: 'Kullanıcı',
      action: 'İşlem',
      resource: 'Kaynak',
      details: 'Detaylar',
      timestamp: 'Zaman',
      noLogs: 'Henüz log kaydı yok.',
    },
  },

  // Client Portal
  client: {
    dashboard: {
      welcomeBack: 'Tekrar hoş geldiniz',
      activityOverview: 'İşte ajans aktivite özetiniz',
      videosDelivered: 'Teslim Edilen Video',
      designsDelivered: 'Teslim Edilen Tasarım',
      contentPublished: 'Yayınlanan İçerik',
      monthlyAdSpend: 'Aylık Reklam Harcaması',
      yourActiveServices: 'Aktif Hizmetleriniz',
      noActiveServices: 'Henüz aktif hizmet yok. Hizmetleri etkinleştirmek için hesap yöneticinizle iletişime geçin.',
      activeAndRunning: 'Aktif ve çalışıyor',
      accessDaysRemaining: 'Kalan Erişim Günü',
      subscriptionExpires: 'Aboneliğinizin süresi',
      days: 'gün',
      accessExpired: 'Erişim Süresi Doldu',
      accessExpiringSoon: 'Erişim {{days}} gün içinde sona eriyor',
      pleaseRenew: 'Hizmetlere erişmeye devam etmek için lütfen aboneliğinizi yenileyin',
      renewSoon: 'Hizmetlerinize erişmeye devam etmek için yakında yenileyin',
      renewNow: 'Şimdi Yenile',
    },
    videos: {
      title: 'Video Prodüksiyon',
      upcomingShoots: 'Yaklaşan Çekimler',
      noUpcomingShoots: 'Yaklaşan çekim yok',
      videoGallery: 'Video Galerisi',
      noVideos: 'Henüz video yok',
      location: 'Konum',
      preparationChecklist: 'Hazırlık Kontrol Listesi',
      approve: 'Onayla',
      requestRevision: 'Revizyon İste',
      approveVideo: 'Videoyu Onayla',
      requestVideoRevision: 'Video Revizyonu İste',
      approveDescription: 'Bu videoyu final olarak onaylayın.',
      revisionDescription: 'Bu video için değişiklik isteyin.',
      addNotes: 'Not ekleyin (isteğe bağlı)',
      statusUpdated: 'Durum başarıyla güncellendi',
      updateFailed: 'Durum güncellenemedi',
    },
    socialMedia: {
      title: 'Sosyal Medya Yönetimi',
      contentCalendar: 'İçerik Takvimi',
      scheduledPosts: 'Programlanmış Paylaşımlar',
      noPosts: 'Henüz paylaşım yok',
      post: 'Gönderi',
      reel: 'Reel',
      story: 'Story',
      draft: 'Taslak',
      waitingApproval: 'Onay Bekliyor',
      approved: 'Onaylandı',
      revision: 'Revizyon',
      published: 'Yayınlandı',
      caption: 'Başlık',
      postDate: 'Paylaşım Tarihi',
    },
    ads: {
      title: 'Meta Reklamları',
      dailySpendReport: 'Günlük Harcama Raporu',
      performanceMetrics: 'Performans Metrikleri',
      monthlyOverview: 'Aylık Özet',
      noReports: 'Henüz rapor yok',
      totalSpend: 'Toplam Harcama',
      totalImpressions: 'Toplam Gösterim',
      totalClicks: 'Toplam Tıklama',
      totalConversions: 'Toplam Dönüşüm',
      avgCPC: 'Ortalama TBM',
      avgCPM: 'Ortalama GBM',
    },
    designs: {
      title: 'Grafik Tasarım',
      designGallery: 'Tasarım Galerisi',
      noDesigns: 'Henüz tasarım yok',
      version: 'Versiyon',
      projectName: 'Proje Adı',
      approveDesign: 'Tasarımı Onayla',
      requestDesignRevision: 'Tasarım Revizyonu İste',
    },
    locked: {
      title: 'Bu hizmet şu anda kilitli',
      description: 'Bu hizmeti etkinleştirmek için paketlerimize göz atın',
      starter: 'Başlangıç',
      professional: 'Profesyonel',
      enterprise: 'Kurumsal',
      perMonth: '/ay',
      custom: 'Özel',
      popular: 'Popüler',
      basicFeatures: 'Temel özellikler',
      emailSupport: 'E-posta desteği',
      monthlyReports: 'Aylık raporlar',
      allStarterFeatures: 'Tüm Başlangıç özellikleri',
      prioritySupport: 'Öncelikli destek',
      advancedAnalytics: 'Gelişmiş analizler',
      allProFeatures: 'Tüm Profesyonel özellikler',
      dedicatedManager: 'Özel hesap yöneticisi',
      customSolutions: 'Özel çözümler',
      specialOffer: '🎉 Mart Özel Teklifi',
      offerDescription: 'Bu ay bu hizmeti aktifleştirdiğinizde ilk 3 ayınızda %50 indirim kazanın!',
      requestOffer: 'Teklif İste',
      contactManager: 'Hesap Yöneticisiyle İletişim',
    },
  },

  // Services
  services: {
    videoProduction: 'Video Çekimi & Prodüksiyon',
    metaAds: 'Meta Reklamları Yönetimi',
    socialMedia: 'Sosyal Medya Yönetimi',
    graphicDesign: 'Grafik Tasarım',
    websiteSetup: 'Web Sitesi Kurulumu',
    ecommerce: 'E-ticaret Yönetimi',
    videoProductionDesc: 'Profesyonel video çekimi ve prodüksiyon hizmetleri',
    metaAdsDesc: 'Facebook ve Instagram reklam yönetimi',
    socialMediaDesc: 'Komple sosyal medya içeriği ve yönetimi',
    graphicDesignDesc: 'Profesyonel grafik tasarım hizmetleri',
    websiteSetupDesc: 'Profesyonel web sitesi geliştirme ve kurulum',
    ecommerceDesc: 'Komple e-ticaret mağaza yönetimi',
  },

  // Status
  status: {
    uploaded: 'Yüklendi',
    approved: 'Onaylandı',
    revisionRequested: 'Revizyon İstendi',
    draft: 'Taslak',
    waitingApproval: 'Onay Bekliyor',
    revision: 'Revizyon',
    published: 'Yayınlandı',
    pending: 'Beklemede',
    rejected: 'Reddedildi',
    active: 'Aktif',
    readOnly: 'Salt Okunur',
    expired: 'Süresi Dolmuş',
  },
};
